import { Button, Descriptions, Drawer, Tooltip } from "antd";
import React from "react";
import { CloseOutlined } from "@ant-design/icons";

const InactiveEmployeeInfo = ({ open, close, selectedData }) => {
  return (
    <Drawer onClose={close} open={open} placement="right" closable={false}>
      <div
        style={{
          height: "100%",
          overflow: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            marginBottom: 10,
          }}
        >
          <div style={{ flexGrow: 1 }}></div>
          <div>
            <Tooltip title="Close">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  close();
                }}
                icon={<CloseOutlined />}
              />
            </Tooltip>
          </div>
        </div>
        {/* <Descriptions column={1}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Image
              width={"auto"}
              height={150}
              src={
                selectedData.product_image !== null
                  ? `${import.meta.env.VITE_API_IMAGE}products/${
                      selectedData.product_image
                    }`
                  : Img
              }
              placeholder={"logo"}
              preview={selectedData.product_image !== null ? true : false}
              alt="product-img"
            />
          </div>
        </Descriptions> */}

        <Descriptions title="Personal Info" column={1}>
          <Descriptions.Item
            label="Name"
            contentStyle={{
              fontWeight: "bold",
            }}
          >
            {selectedData.firstname} {selectedData.lastname}
          </Descriptions.Item>

          <Descriptions.Item
            label="Address"
            contentStyle={{
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            {selectedData.street}, {selectedData.barangay}, {selectedData.city},{" "}
            {selectedData.province}
          </Descriptions.Item>

          <Descriptions.Item
            label="Contact #"
            contentStyle={{
              fontWeight: "bold",
            }}
          >
            {selectedData.contact_no}
          </Descriptions.Item>

          <Descriptions.Item
            label="Position"
            contentStyle={{
              fontWeight: "bold",
            }}
          >
            {selectedData.merchantemployeeposition.position}
          </Descriptions.Item>

          <Descriptions.Item
            label="Status"
            contentStyle={{
              fontWeight: "bold",
              color: parseInt(selectedData.status) === 1 ? "green" : "red",
            }}
          >
            {parseInt(selectedData.status) === 1 ? "Active" : "Inactive"}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </Drawer>
  );
};

export default InactiveEmployeeInfo;
